module.exports = __webpack_public_path__ + "static/media/Creative.b39890f5.jpg";